import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import SettingsCard from '../../../components/Settings/SettingsCard'
import CharityStripeConnectSection from '../dashboard/stripe-connect-section'

export default function CharityVerificationCard({
  charityId,
  returnPath,
  onStatusChange,
  onVerificationComplete,
}) {
  const { t } = useTranslation()

  return (
    <SettingsCard icon="building" title={t('charities.dashboard.stripe.title')}>
      <CharityStripeConnectSection
        charityId={charityId}
        returnPath={returnPath}
        onStatusChange={onStatusChange}
        onVerificationComplete={onVerificationComplete}
      />
    </SettingsCard>
  )
}

CharityVerificationCard.propTypes = {
  charityId: PropTypes.number.isRequired,
  onStatusChange: PropTypes.func,
  onVerificationComplete: PropTypes.func,
  returnPath: PropTypes.string,
}
